import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DealerReviewGoodView } from 'site-modules/dealerships/components/dealer-review-good-view/dealer-review-good-view';
import { DealerReviewNoReviewsView } from 'site-modules/shared/components/dealer-review-no-reviews-view/dealer-review-no-reviews-view';
import { ReviewEntities } from 'client/data/models/dealer-reviews';
import { DEFAULT_REVIEWS_TYPE, REVIEWS_ALL, REVIEWS_SALES, DEALER_PROPS } from 'client/constants/dealer-reviews';

export class DealerReviewsView extends Component {
  createWriteReviewLink = () => {
    const { params, showroomPage, reviewsType: reviewsTypeFromProps } = this.props;
    const reviewsType = reviewsTypeFromProps === REVIEWS_ALL ? REVIEWS_SALES : reviewsTypeFromProps;
    const { dealerState, dealerCity, logicalName } = params;
    return showroomPage
      ? `${showroomPage.replace('/all/', '/')}/create-${reviewsType}-review.html`
      : `/dealerships/${dealerState}/${dealerCity}/${logicalName}/create-${reviewsType}-review.html`;
  };

  createReadReviewsLink = () => {
    const { params, showroomPage, reviewsType: reviewsTypeFromProps } = this.props;
    const reviewsType = reviewsTypeFromProps === REVIEWS_ALL ? REVIEWS_SALES : reviewsTypeFromProps;
    const { dealerState, dealerCity, logicalName } = params;

    return showroomPage
      ? `${showroomPage.replace('/all/', '/')}/${reviewsType}.1.html`
      : `/dealerships/${dealerState}/${dealerCity}/${logicalName}/${reviewsType}.1.html`;
  };

  render() {
    const { overallData, featuredReview, reviewsType, showroomPage, params, isMobile } = this.props;
    const writeReviewLink = this.createWriteReviewLink();
    if (overallData && overallData.totalCount) {
      const readReviewsLink = this.createReadReviewsLink();

      return (
        <DealerReviewGoodView
          reviewsType={reviewsType}
          overallData={overallData}
          featuredReview={featuredReview}
          params={params}
          writeReviewLink={writeReviewLink}
          readReviewsLink={readReviewsLink}
          showroomPage={showroomPage}
          isMobile={isMobile}
        />
      );
    }

    return (
      <DealerReviewNoReviewsView
        reviewsType={reviewsType}
        params={params}
        noFollowWriteReviewLink
        showroomPage={showroomPage}
        isMobile={isMobile}
      />
    );
  }
}

DealerReviewsView.propTypes = {
  params: DEALER_PROPS.isRequired,
  reviewsType: PropTypes.string,
  overallData: ReviewEntities.OverallRatingEntity,
  featuredReview: ReviewEntities.ReviewEntity,
  showroomPage: PropTypes.string,
  isMobile: PropTypes.bool,
};

DealerReviewsView.defaultProps = {
  reviewsType: DEFAULT_REVIEWS_TYPE,
  overallData: {},
  featuredReview: null,
  showroomPage: '',
  isMobile: false,
};
